import(/* webpackMode: "eager" */ "C:\\Auto-IT\\Apps\\CloudAdmin\\src\\app\\(pageRoutes)\\(auth)\\forgot\\page.tsx");
